// extracted by mini-css-extract-plugin
export default {"mCard":"FE-z","image":"GE-z","imageNoBackground":"HE-z","imageHasCategory":"IE-z","fullWidth":"JE-z"};